import React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { SummaryCard } from "./SummaryCard";
import { FollowUpsCard } from "./FollowUpsCard";
import { UpcomingEventsCard } from "./UpcomingEventsCard";
import { GetStartedCard } from "./GetStartedCard";
import { NestifyzMigrationCard } from "./NestifyzMigrationCard";
import { ProfileCompletionCard } from "./ProfileCompletionCard";
import { RecentGamesCard } from "./RecentGamesCard";
import { RecentPlayTestsCard } from "./RecentPlayTestsCard";
import { AnnouncementCard } from "./AnnouncementCard";
import { UpcomingMeetingsCard } from "../sessions/UpcomingMeetingsCard";
import { TasksCard } from "./TasksCard";
import Grid from "@mui/material/Grid";

export const Dashboard = () => {
  return (
    <Box pl={2} pr={2}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Stack spacing={1}>
            <GetStartedCard />
            <NestifyzMigrationCard />
            <ProfileCompletionCard />
            <SummaryCard />
            <UpcomingMeetingsCard />
            <FollowUpsCard />
            <AnnouncementCard />
            <UpcomingEventsCard />
            <RecentGamesCard />
            <RecentPlayTestsCard />
            <TasksCard />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};
